import type { Inventory } from './inventory';
import type { ProductHit } from './productHit';

enum SelectedValueKey {
    SIZE = 'size',
    FLAVOR = 'flavor',
    COLOR = 'color',
    QUANTITY = 'quantity',
    WATTAGE = 'wattage',
}

enum SelectedPersonalizationKey {
    FONT_FACE = 'fontFaceOptions',
    THREAD_COLORS = 'styleOptions.threadColors',
}

const SELECTED_VARIANT_KEYS = {
    ...SelectedValueKey,
    ...SelectedPersonalizationKey,
};

type SelectedVariantKeys =
    (typeof SELECTED_VARIANT_KEYS)[keyof typeof SELECTED_VARIANT_KEYS];

type SelectedVariants = Record<
    Partial<SelectedVariantKeys>,
    string | undefined
>;

type ProductVariantInventory = Record<string, Inventory>;

type InStockVariant = {
    bopis: boolean;
    sdd: boolean;
    web: boolean;
};

type VariantValue = {
    key: string;
    value: string;
    display?: string;
};

type UniqueVariants = Partial<Record<SelectedVariantKeys, VariantValue[]>>;

type LocaleRecord<T> = {
    ca: T;
    us: T;
};

type ProductVariant = Omit<ProductHit, '__position'> & {
    // TODO: IMPORTANT!!! Review if these types will exist in the new Algolia structure.
    categoryAssignments?: {
        primary: {
            name: string;
            id: number;
        };
        alternates?: {
            name: string;
            id: number;
        }[];
    };
    petType?: {
        pets: string[];
    };
    productType?: string;
    shoppingOptions?: {
        isBopisEligible: LocaleRecord<boolean>;
        isInStoreAvailable: boolean;
        isInStoreOnly: boolean;
        isInStorePickUp: boolean;
        isSoldOnlineOnly: boolean;
    };
    flavor?: {
        displays: string;
        value: string;
    };
};

type MappedProductVariant = ProductVariant & {
    variants?: Record<string, VariantValue>;
};

type ProductVariants = {
    variants: MappedProductVariant[];
    uniqueVariants: UniqueVariants;
};

export type {
    InStockVariant,
    SelectedVariantKeys,
    MappedProductVariant,
    ProductVariant,
    ProductVariants,
    ProductVariantInventory,
    UniqueVariants,
    VariantValue,
    SelectedVariants,
};

export {
    SELECTED_VARIANT_KEYS,
    SelectedValueKey as MappingVariantKeys,
    SelectedValueKey,
    SelectedPersonalizationKey,
};
